import PartnerAuthModals from "./PartnerAuthModals";

export default PartnerAuthModals;
